import { Container, Row, Col } from 'react-bootstrap';
import FormatStatsPanel from './format-stats-panel';
import type { FormatMemberStats, FormatSummary } from './format-stats.utils';

interface FormatStatsPageProps {
  mapFormatSummary: Map<string, Map<string | number, FormatMemberStats>>;
  formatsPlayedSorted: FormatSummary[];
  activeFormat: string;
  onFormatChange: (format: string) => void;
}

export default function FormatStatsPage({
  mapFormatSummary,
  formatsPlayedSorted,
  activeFormat,
  onFormatChange,
}: FormatStatsPageProps) {
  const tabNavigation = formatsPlayedSorted.map((format) => (
    <button
      key={format.formatName}
      className={`sub-nav-link ${activeFormat === format.formatName ? 'active' : ''}`}
      onClick={() => onFormatChange(format.formatName)}
      type="button"
    >
      {format.formatName}
    </button>
  ));

  const activeFormatData = mapFormatSummary.get(activeFormat);

  return (
    <Container>
      <Row>
        <Col sm={12}>
          <h2>Ryd-Her Cup Format Stats</h2>
          <div className="sub-nav">{tabNavigation}</div>
          {activeFormatData && <FormatStatsPanel formatName={activeFormat} memberFormatTotals={activeFormatData} />}
        </Col>
      </Row>
    </Container>
  );
}
